<div id="ey-navbar-container">
    <div id="ey-app-home" class="ey-app-home">
        <div class="ey-max-container">

            <img class="ey-bg-logo" src="assets/images/ey-bg-log-3-4.png" />
            <div id="sign-in-container" class="sign-in-container">

                <div  id="login-btn" class="loginButton" >

                    <button  type="button" class="ey-button mt-0 ey-sign-btn" (click)='redirectDashboard()'>
                        Sign In
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
